import {FolderOutlined, CheckCircleOutlined, ClockCircleOutlined, LineChartOutlined, TrophyOutlined,  } from "@ant-design/icons";
import { Card, Row, Col, Typography, Space, Tooltip, Progress } from "antd";

const { Title, Text } = Typography;

export function KpiCards({ data = {}, filters = {} }) {
  const tareas = data?.todasLasTareas || [];
  const proyectos = data?.proyectos || [];

  const totalProyectos = proyectos.length;

  let filteredTasks = [...tareas];
  if (filters.proyecto)
    filteredTasks = filteredTasks.filter(
      (t) => t.proyectoCodigo === filters.proyecto
    );
  if (filters.fase)
    filteredTasks = filteredTasks.filter((t) => t.fase === filters.fase);
  if (filters.estado && filters.estado !== "all")
    filteredTasks = filteredTasks.filter((t) => t.estado === filters.estado);

  const tareasSobrecumplidas = filteredTasks.filter(
    (t) => Number(t.porcentajePromedio) > 100
  ).length;
  const tareasCompletadas = filteredTasks.filter(
    (t) => Number(t.porcentajePromedio) === 100
  ).length;
  const tareasPendientes =
    filteredTasks.length - (tareasCompletadas + tareasSobrecumplidas);

  const porcentajePromedio =
    filteredTasks.length > 0
      ? filteredTasks.reduce((sum, t) => sum + (t.porcentajePromedio || 0), 0) /
        filteredTasks.length
      : 0;

  const kpis = [
    {
      title: "Total Proyectos",
      value: totalProyectos,
      icon: <FolderOutlined style={{ color: "#317EDA", fontSize: 22 }} />,
      color: "#317EDA",
    },
    {
      title: "Tareas Sobrecumplidas",
      value: tareasSobrecumplidas,
      subtitle:
        tareasSobrecumplidas > 0
          ? `${((tareasSobrecumplidas / filteredTasks.length) * 100).toFixed(
              1
            )}% del total`
          : "0%",
      icon: <TrophyOutlined style={{ color: "#00E676", fontSize: 22 }} />,
      color: "#00E676",
    },
    {
      title: "Tareas Completadas",
      value: tareasCompletadas,
      subtitle: `de ${filteredTasks.length} tareas`,
      icon: <CheckCircleOutlined style={{ color: "#009728", fontSize: 22 }} />,
      color: "#009728",
    },
    {
      title: "Tareas Pendientes",
      value: tareasPendientes,
      subtitle:
        filteredTasks.length > 0
          ? `${((tareasPendientes / filteredTasks.length) * 100).toFixed(
              1
            )}% del total`
          : "0%",
      icon: <ClockCircleOutlined style={{ color: "#338BC7", fontSize: 22 }} />,
      color: "#338BC7",
    },
    {
      title: "Avance Ponderado",
      value: `${porcentajePromedio.toFixed(1)}%`,
      icon: <LineChartOutlined style={{ color: "#7EE22E", fontSize: 22 }} />,
      color: "#7EE22E",
      progress: porcentajePromedio,
    },
  ];

  return (
    <Row
      gutter={[16, 16]}
      justify="space-between"
      align="stretch"
      wrap={false} 
      style={{
        width: "100%",
        overflowX: "auto",
      }}
    >
      {kpis.map((kpi, index) => (
        <Col
          key={index}
          flex="1"
          style={{
            display: "flex",
            minWidth: "20%",
          }}
        >
          <Card
            hoverable
            style={{
              flex: 1,
              borderRadius: 12,
              padding: 16,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              minHeight: 160,
            }}
          >
            <Space
              direction="vertical"
              style={{ width: "100%", height: "100%" }}
              size="small"
            >
              <Row justify="space-between" align="middle">
                <Col>
                  <Text strong style={{ fontSize: 14, color: "#042956" }}>
                    {kpi.title}
                  </Text>
                </Col>
                <Col>
                  <div
                    style={{
                      backgroundColor: `${kpi.color}20`,
                      borderRadius: 8,
                      padding: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {kpi.icon}
                  </div>
                </Col>
              </Row>

              <Title level={3} style={{ margin: "8px 0 0", color: "#042956" }}>
                {kpi.value}
              </Title>

              {kpi.subtitle && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {kpi.subtitle}
                </Text>
              )}

              {kpi.progress !== undefined && (
                <Tooltip
                  title={`Avance general: ${porcentajePromedio.toFixed(1)}%`}
                >
                  <Progress
                    percent={Number(porcentajePromedio.toFixed(1))}
                    showInfo={false}
                    strokeColor={kpi.color}
                    size="small"
                    style={{ marginTop: 8 }}
                  />
                </Tooltip>
              )}
            </Space>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
